export function mockLuxLoyaltyAccountEligibilityResponse() {
  return {
    status: 200,
    result: {
      eligibility: {
        tier: 'silver',
      },
    },
  }
}

export function mockLuxLoyaltyProgramConfigResponse() {
  return {
    status: 200,
    result: {
      config: {
        programName: 'luxloyalty',
        currencyName: 'points',
        statusCreditsName: 'status credits',
        tierLabel: 'traveller status',
        tiers: {
          gold: {
            tierName: 'gold',
            welcomePoints: 2000,
          },
          silver: {
            tierName: 'silver',
            welcomePoints: 1000,
          },
          platinum: {
            tierName: 'platinum',
            welcomePoints: 3000,
          },
        },
      },
    },
  }
}
